import { render, staticRenderFns } from "./pageeditglentry.vue?vue&type=template&id=b0656238&scoped=true&"
import script from "./pageeditglentry.vue?vue&type=script&lang=js&"
export * from "./pageeditglentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0656238",
  null
  
)

export default component.exports